var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-container",on:{"click":function($event){$event.stopPropagation();return _vm.cancel.apply(null, arguments)}}},[_c('div',{ref:"popup",staticClass:"popup",style:({
			left: `${_vm.menuX - _vm.width / 2}px`,
			top: `${_vm.menuY - _vm.height / 2}px`,
			'font-size': `${16 * (1 / _vm.scale)}px`,
			width: `${_vm.width}px`
		}),on:{"click":_vm.cancel}},[_c('header',[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])]),_c('section',[_vm._v(" "+_vm._s(_vm.item.instruction || "Instruktion")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }